/** @format */

import {Box} from '@mui/material';
import {styled} from '@mui/material/styles';

import {providerNewIconSrc} from 'helpers/imageHelpers';
import {TokenType} from 'pages/Home/Settings/Connect/types';

const PREFIX = 'ConnectedProvidersNew';

const classes = {
  icon: `${PREFIX}-icon`,
  iconsContainer: `${PREFIX}-iconsContainer`,
};

const StyledBox = styled(Box)(({theme}) => ({
  [`& .${classes.icon}`]: {
    marginLeft: theme.spacing(4),
    '&:first-of-type': {
      marginLeft: 0,
    },
  },

  [`&.${classes.iconsContainer}`]: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(4),
    borderRadius: '8px',
    background: '#2B2B2B',
    [theme.breakpoints.down('md')]: {
      marginTop: theme.spacing(4),
    },
  },
}));

interface Props {
  adTypes: string[];
  tokens: ReadonlyArray<TokenType>;
}

const ConnectedProvidersNew = ({adTypes, tokens}: Props) => {
  return (
    <StyledBox className={classes.iconsContainer}>
      {adTypes.includes('CONTEXT') && (
        <>
          {tokens.find(v => v.provider === 'YANDEX') && (
            <img alt='Icon' className={classes.icon} src={providerNewIconSrc('YANDEX', 20)} />
          )}
          {tokens.find(v => v.provider === 'GOOGLE') && (
            <img alt='Icon' className={classes.icon} src={providerNewIconSrc('GOOGLE', 20)} />
          )}
        </>
      )}
      {adTypes.includes('TARGET') && (
        <>
          {tokens.find(v => v.provider === 'VKONTAKTE') && (
            <img alt='Icon' className={classes.icon} src={providerNewIconSrc('VKONTAKTE', 20)} />
          )}
          {tokens.find(v => v.provider === 'VKONTAKTE_ADS') && (
            <img
              alt='Icon'
              className={classes.icon}
              src={providerNewIconSrc('VKONTAKTE_ADS', 20)}
            />
          )}
          {tokens.find(v => v.provider === 'FACEBOOK') && (
            <img alt='Icon' className={classes.icon} src={providerNewIconSrc('FACEBOOK', 20)} />
          )}
        </>
      )}
      {adTypes.includes('STATS') && (
        <>
          {tokens.find(v => v.provider === 'METRIKA') && (
            <img alt='Icon' className={classes.icon} src={providerNewIconSrc('METRIKA', 20)} />
          )}
          {tokens.find(v => v.provider === 'WEBDAV') && (
            <img alt='Icon' className={classes.icon} src={providerNewIconSrc('WEBDAV', 20)} />
          )}
        </>
      )}
    </StyledBox>
  );
};

export default ConnectedProvidersNew;
